<template>
  <div>
    <property-input-component ref="propertyInputComponent"
                              :address-type="addressType"
                              :compact="true"
                              :default-property-id="defaultPropertyId"
                              :emit-events="true" :only-delete-button="true"
                              input-name="post_property_id"
                              v-on:property-selected="handlePropertySelected"
                              v-on:property-deleted="handlePropertyDeleted"
    ></property-input-component>
  </div>
</template>
<script>
import ExternalPersonPropertyApi from '~/api/external_person_property';
import ExternalPersonApi from '~/api/external_person'

export default {
  name: "EditExternalPersonProperty",
  components: {},
  props: {
    externalPersonId: {
      required: true,
      type: [Number, String]
    },
    addressType: {
      required: true,
      type: String,
    },
    defaultPropertyId: {
      required: true,
      type: [String, Number],
    }
  },
  data() {
    return {
      externalPerson: null,
      property: null,
      externalPersonProperty: null,
    };
  },
  mounted() {
    if (this.externalPersonId === null) {
      throw new Error('The externalPerson id is required.');
    }

    this.initExternalPerson()
  },
  computed: {
    hasExternalPersonProperty() {
      return typeof this.externalPersonProperty !== "undefined" && this.externalPersonProperty !== null;
    },

  },
  methods: {
    initExternalPerson() {
      return new Promise((resolve, reject) => {
        ExternalPersonApi.findById(this.externalPersonId).then(response => {
          this.externalPerson = response.data;
          resolve(this.externalPerson);
          this.initExternalPersonProperty()
        }).catch(reject);
      });
    },
    initExternalPersonProperty() {
      return new Promise((resolve, reject) => {
        ExternalPersonPropertyApi.findCurrentByExternalPersonAndAddressType(this.externalPerson.id, this.addressType).then(response => {
          this.externalPersonProperty = response.data
          resolve(this.customerProperty);
        })
      });
    },
    handlePropertySelected(property) {
      this.property = property
      this.handleCreateExternalPersonProperty()
    },
    handlePropertyDeleted() {
      this.property = null
      ExternalPersonPropertyApi.delete(this.externalPersonProperty.id).then(response => {
        this.externalPersonProperty = null
        this.$nextTick(() => {
          this.$refs.propertyInputComponent.handleShowPropertyCreate();
        });
      }).catch()
    },

    handleCreateExternalPersonProperty() {
      ExternalPersonPropertyApi.findOrCreateCurrentByExternalPersonAndPropertyAndAddressType(this.externalPerson.id, this.property.id, this.addressType).then(response => {
        this.externalPersonProperty = response.data;
      }).catch()
    }
  }
}
</script>
<style scoped>
.create-customer-properties {
  position: relative;
  margin-bottom: 15px;
}

.create-button {
  margin-top: 15px;
}

.address-label {
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-weight: 500;
}
</style>
